import React, { useState, useEffect, useRef } from "react";
import { FaCalendarTimes, FaCheckCircle } from "react-icons/fa";
import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  Row,
  Modal,
  Form,
  Table
} from "react-bootstrap";
import { FaEdit, FaWpforms, FaPrint,FaDownload } from "react-icons/fa";
import { MdAccessTime, MdArrowForward, MdArrowBack, MdDelete } from "react-icons/md";
import { IoEye } from "react-icons/io5";
import { TbReplaceFilled } from "react-icons/tb";

import axios from "axios";
import { Link } from "react-router-dom";
import AtdLayout from "../../Components/AttendanceLayout";

export const ViewAtdDay = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [modalData, setModalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showEarlyLeaveApprovalModal, setShowEarlyLeaveApprovalModal] = useState(false);
  const [showLateApprovalModal, setShowLateApprovalModal] = useState(false);
  const [showOvertimeApprovalModal, setShowOvertimeApprovalModal] = useState(false);
  const [approvalData, setApprovalData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [hrSignature, setHrSignature] = useState("");
  const [adminSignature, setAdminSignature] = useState("");
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [applySingleDeduction, setApplySingleDeduction] = useState(false);
  const [lateDocs, setLateDocs] = useState({});
  const [earlyCloseDocs, setEarlyCloseDocs] = useState({});
  const [overtimeDocs, setOvertimeDocs] = useState({});
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [docCategory, setDocCategory] = useState("");
  const printRef = useRef(null);
  const fileInputRef = useRef(null);
  const role = localStorage.getItem("role");

  useEffect(() => {
    fetchAttendance(selectedDate);
  }, [selectedDate]);

  const fetchAttendance = async (date) => {
    setLoading(true);
    try {
      const formattedDate = date.toISOString().split("T")[0];
      console.log("Fetching data for date:", formattedDate);

      const response = await axios.get(
        `https://backend.ems.hiradentallab.com/api/attendance?date=${formattedDate}`
      );

      if (response.data.success) {
        const attendanceData = response.data.data || [];
        const processedData = attendanceData.map((item) => ({
          ...item,
          lateMinutes: item.lateMinutes ?? 0,
          earlyCloseMinutes: item.earlyCloseMinutes ?? 0,
          extraMinutes: item.extraMinutes ?? 0,
          totalLostMinutes: item.totalLostMinutes ?? ((item.lateMinutes ?? 0) + (item.earlyCloseMinutes ?? 0)),
          lateReason: item.lateReason ?? "Not provided",
          earlyCloseReason: item.earlyCloseReason ?? "Not provided",
          overtimeReason: item.overtimeReason ?? "Not provided",
          lateApproved: item.lateApproved ?? false,
          earlyCloseApproved: item.earlyCloseApproved ?? false,
          overtimeApproved: item.overtimeApproved ?? false,
          lateSemiApproved: item.lateSemiApproved ?? false,
          earlyCloseSemiApproved: item.earlyCloseSemiApproved ?? false,
          overtimeSemiApproved: item.overtimeSemiApproved ?? false,
          lateHrSignature: item.lateHrSignature ?? "",
          lateAdminSignature: item.lateAdminSignature ?? "",
          earlyCloseHrSignature: item.earlyCloseHrSignature ?? "",
          earlyCloseAdminSignature: item.earlyCloseAdminSignature ?? "",
          overtimeHrSignature: item.overtimeHrSignature ?? "",
          overtimeAdminSignature: item.overtimeAdminSignature ?? "",
          lateSingleDeduction: item.lateSingleDeduction ?? false,
          earlyCloseSingleDeduction: item.earlyCloseSingleDeduction ?? false,
        }));

        const lateDocs = {};
        const earlyCloseDocs = {};
        const overtimeDocs = {};
        attendanceData.forEach((item) => {
          lateDocs[item._id] = item.lateDocs ? item.lateDocs : null;
          earlyCloseDocs[item._id] = item.earlyCloseDocs ? item.earlyCloseDocs : null;
          overtimeDocs[item._id] = item.overtimeDocs ? item.overtimeDocs : null;
        });

        setData(processedData);
        setLateDocs(lateDocs);
        setEarlyCloseDocs(earlyCloseDocs);
        setOvertimeDocs(overtimeDocs);
      } else {
        setData([]);
        setLateDocs({});
        setEarlyCloseDocs({});
        setOvertimeDocs({});
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
      setData([]);
      setLateDocs({});
      setEarlyCloseDocs({});
      setOvertimeDocs({});
    }
    setLoading(false);
  };

  const handleDateChange = (direction) => {
    setSelectedDate((prevDate) => {
      let newDate = new Date(prevDate);
      newDate.setDate(
        direction === "forward"
          ? prevDate.getDate() + 1
          : prevDate.getDate() - 1
      );
      return newDate;
    });
  };

  const handlePageChange = (pageNumber) => {
    const totalPages = Math.ceil(data.length / rowsPerPage);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const pageRange = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(startPage + 4, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const resetApprovalData = () => {
    setApprovalData({});
    setHrSignature("");
    setAdminSignature("");
    setIsViewOnly(false);
    setApplySingleDeduction(false);
  };

  const handleShowModal = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData({});
  };

  const handleViewDocument = (docUrl, item, category) => {
    if (!docUrl || !item || !item._id) {
      console.error("Invalid document or item:", { docUrl, item });
      alert("Something went wrong. Document or attendance data missing.");
      return;
    }

    let formattedUrl = docUrl.startsWith("http")
      ? docUrl
      : `http://localhost:5544${
          docUrl.startsWith("/uploads") ? docUrl : `/uploads/${docUrl}`
        }`;

    setSelectedDocUrl(formattedUrl);
    setSelectedDocId(item._id);
    setDocCategory(category);
    setShowViewModal(true);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(selectedDocUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const filename = selectedDocUrl.split("/").pop() || "document";
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed. Please try again.");
    }
  };

  const handleFileReplace = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedDocId || !docCategory) {
      alert("No file selected, attendance ID missing, or document category not specified.");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);
    formData.append("uploadCategory", docCategory);

    try {
      const response = await fetch(
        `https://backend.ems.hiradentallab.com/api/attendance/update-document/${selectedDocId}`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();

      if (response.ok) {
        alert("Document replaced successfully!");
        setShowViewModal(false);
        fetchAttendance(selectedDate);
      } else {
        alert(data.message || "Failed to replace document");
      }
    } catch (error) {
      console.error("Error replacing file:", error);
      alert("Error replacing file.");
    }
  };

  const handleOpenEarlyLeaveApprovalForm = (item) => {
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.earlyCloseHrSignature;
    const adminHasApproved = !!item.earlyCloseAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin" && !adminHasApproved;

    setApprovalData({
      userName: item.userName || "--",
      userId: item.userId || "--",
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || "Not specified",
      type: "Early Leave",
      minutes: item.earlyCloseMinutes || 0,
      reason: item.earlyCloseReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.earlyCloseSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole
    });
    setHrSignature(item.earlyCloseHrSignature || "");
    setAdminSignature(item.earlyCloseAdminSignature || "");
    setApplySingleDeduction(item.earlyCloseSingleDeduction || false);
    setIsViewOnly(!canEditHRSignature && !canEditAdminSignature);
    setShowEarlyLeaveApprovalModal(true);
  };

  const handleOpenLateApprovalForm = (item) => {
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.lateHrSignature;
    const adminHasApproved = !!item.lateAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin" && !adminHasApproved;

    setApprovalData({
      userName: item.userName || "--",
      userId: item.userId || "--",
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || "Not specified",
      type: "Late Arrival",
      minutes: item.lateMinutes || 0,
      reason: item.lateReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.lateSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole
    });
    setHrSignature(item.lateHrSignature || "");
    setAdminSignature(item.lateAdminSignature || "");
    setApplySingleDeduction(item.lateSingleDeduction || false);
    setIsViewOnly(!canEditHRSignature && !canEditAdminSignature);
    setShowLateApprovalModal(true);
  };

  const handleOpenOvertimeApprovalForm = (item) => {
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.overtimeHrSignature;
    const adminHasApproved = !!item.overtimeAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin" && !adminHasApproved;

    setApprovalData({
      userName: item.userName || "--",
      userId: item.userId || "--",
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || "Not specified",
      type: "Overtime",
      minutes: item.extraMinutes || 0,
      reason: item.overtimeReason || "Not provided",
      attendanceId: item._id,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole
    });
    setHrSignature(item.overtimeHrSignature || "");
    setAdminSignature(item.overtimeAdminSignature || "");
    setIsViewOnly(!canEditHRSignature && !canEditAdminSignature);
    setShowOvertimeApprovalModal(true);
  };

  const handleApprove = async (type) => {
    if (!role || (role !== "HR" && role !== "admin")) {
      alert("You do not have permission to approve this request. Please log in as HR or Admin.");
      return;
    }

    if (role === "HR" && !hrSignature) {
      alert("Please provide an HR signature.");
      return;
    }
    if (role === "admin" && !adminSignature) {
      alert("Please provide an Admin signature.");
      return;
    }

    try {
      const normalizedType = type === "earlyClose" ? "earlyClose" : type.toLowerCase();
      const updateData = {
        type: normalizedType,
        approve: role === "admin" ? true : undefined,
        semiApproved: role === "HR" ? true : undefined,
        deduct: normalizedType !== "overtime" && role === "admin" ? !applySingleDeduction : undefined,
        singleDeduction: normalizedType !== "overtime" && role === "admin" ? applySingleDeduction : undefined,
        hrSignature: role === "HR" ? hrSignature : undefined,
        adminSignature: role === "admin" ? adminSignature : undefined,
      };

      const response = await axios.put(
        `https://backend.ems.hiradentallab.com/api/attendance/${approvalData.attendanceId}/deduct`,
        updateData,
        {
          headers: {
            'x-user-role': role
          }
        }
      );

      if (response.status === 200) {
        alert(`Attendance ${normalizedType} ${role === "admin" ? "approved" : "semi-approved"} successfully!`);
        const signatureFields = {
          late: {
            hrSignatureField: "lateHrSignature",
            adminSignatureField: "lateAdminSignature",
            minutesField: "lateMinutes",
            singleDeductionField: "lateSingleDeduction",
            deductedField: "lateDeducted"
          },
          earlyClose: {
            hrSignatureField: "earlyCloseHrSignature",
            adminSignatureField: "earlyCloseAdminSignature",
            minutesField: "earlyCloseMinutes",
            singleDeductionField: "earlyCloseSingleDeduction",
            deductedField: "earlyCloseDeducted"
          },
          overtime: {
            hrSignatureField: "overtimeHrSignature",
            adminSignatureField: "overtimeAdminSignature",
            minutesField: "extraMinutes"
          },
        };
        setData((prev) =>
          prev.map((item) =>
            item._id === approvalData.attendanceId
              ? {
                  ...item,
                  [`${normalizedType}Approved`]: role === "admin" ? true : item[`${normalizedType}Approved`],
                  [`${normalizedType}SemiApproved`]: role === "HR" ? true : item[`${normalizedType}SemiApproved`],
                  ...(normalizedType !== "overtime" && role === "admin"
                    ? {
                        [signatureFields[normalizedType].deductedField]: !applySingleDeduction,
                        [signatureFields[normalizedType].singleDeductionField]: applySingleDeduction,
                        [signatureFields[normalizedType].minutesField]: response.data.data[signatureFields[normalizedType].minutesField]
                      }
                    : {}),
                  [signatureFields[normalizedType].hrSignatureField]: role === "HR" ? hrSignature : item[signatureFields[normalizedType].hrSignatureField],
                  [signatureFields[normalizedType].adminSignatureField]: role === "admin" ? adminSignature : item[signatureFields[normalizedType].adminSignatureField],
                  totalLostMinutes: response.data.data.totalLostMinutes || ((response.data.data.lateMinutes || 0) + (response.data.data.earlyCloseMinutes || 0)),
                }
              : item
          )
        );
        if (type === "late") setShowLateApprovalModal(false);
        if (type === "earlyClose") setShowEarlyLeaveApprovalModal(false);
        if (type === "overtime") setShowOvertimeApprovalModal(false);
        resetApprovalData();
      } else {
        alert("Failed to approve attendance record.");
      }
    } catch (error) {
      console.error("Error approving attendance:", error.response?.data || error);
      alert(
        "Error approving attendance record: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const handleDeleteClick = (item) => {
    setDeleteItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteAttendance = async () => {
    if (!deleteItem) return;

    setDeleting(true);
    try {
      const response = await axios.post(
        "https://backend.ems.hiradentallab.com/api/attendance/attendance/delete",
        {
          attendanceId: deleteItem._id,
          userId: deleteItem.userId,
          date: new Date(deleteItem.checkIn).toISOString().split("T")[0],
        }
      );

      if (response.data.success) {
        alert("Attendance record deleted successfully!");
        setLateDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[deleteItem._id];
          return newDocs;
        });
        setEarlyCloseDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[deleteItem._id];
          return newDocs;
        });
        setOvertimeDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[deleteItem._id];
          return newDocs;
        });
        fetchAttendance(selectedDate);
      } else {
        alert(response.data.message || "Failed to delete attendance record");
      }
    } catch (error) {
      console.error("Error deleting attendance:", error);
      alert(
        error.response?.data?.message ||
          "An error occurred while deleting the attendance record"
      );
    } finally {
      setDeleting(false);
      setShowDeleteModal(false);
      setDeleteItem(null);
    }
  };

  return (
    <AtdLayout>
      <div>
        <h1 className="yesterday-attendance-title">
          <FaCalendarTimes /> View ATD
        </h1>
        <hr />

        <div className="available-leaves-content">
          <div className="available-leaves-actions">
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                <Dropdown as={ButtonGroup}>
                  <Button variant="primary">Show Entries</Button>
                  <Dropdown.Toggle
                    split
                    variant="primary"
                    id="dropdown-split-basic"
                  />
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setRowsPerPage(10)}>
                      10
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setRowsPerPage(25)}>
                      25
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setRowsPerPage(50)}>
                      50
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setRowsPerPage(100)}>
                      100
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
                <div
                  style={{
                    backgroundColor: "#fff",
                    width: "250px",
                    textAlign: "center",
                    borderRadius: "8px",
                    padding: "8px",
                  }}
                >
                  <button
                    className="date-nav-btn"
                    onClick={() => handleDateChange("backward")}
                  >
                    <MdArrowBack />
                  </button>
                  <span className="date-display">
                    {selectedDate.toDateString()}
                  </span>
                  <button
                    className="date-nav-btn"
                    onClick={() => handleDateChange("forward")}
                  >
                    <MdArrowForward />
                  </button>
                </div>
              </Col>
            </Row>
          </div>

          <div className="table-responsive">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <Table striped hover className="table-style">
                <thead className="yesterday-attendance-table-header">
                  <tr className="table-header">
                    <th>SR</th>
                    <th>UserId</th>
                    <th>Employee Name</th>
                    <th>CheckIn</th>
                    <th>CheckOut</th>
                    <th>Worked Hours</th>
                    <th>Late Absent Minutes</th>
                    <th>Early Absent Minutes</th>
                    <th>Overtime</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data
                    .slice(
                      (currentPage - 1) * rowsPerPage,
                      currentPage * rowsPerPage
                    )
                    .map((item, index) => (
                      <tr key={item._id || index}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{item.userId || "--"}</td>
                        <td>{item.userName || "--"}</td>
                        <td>
                          {item.checkIn
                            ? new Date(item.checkIn).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "--"}
                        </td>
                        <td>
                          {item.checkOut
                            ? new Date(item.checkOut).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "At Work"}
                        </td>
                        <td>{item.workedHours || "--"}</td>
                        <td>
                          {item.lateMinutes || "0"}
                          {lateDocs[item._id] && (
                            <Button
                              style={{
                                color: "#fff",
                                textDecoration: "none",
                                fontWeight: "500",
                                padding: "4px 8px",
                                backgroundColor: "#17a2b8",
                                borderRadius: "4px",
                                cursor: "pointer",
                                marginLeft: "9px",
                                border: "none",
                              }}
                              onClick={() =>
                                handleViewDocument(lateDocs[item._id], item, "late")
                              }
                            >
                              <IoEye />
                            </Button>
                          )}
                          {item.lateMinutes > 0 && (
                            <Button
                              variant={item.lateApproved ? "success" : "danger"}
                              size="sm"
                              style={{ marginLeft: "5px" }}
                              onClick={() => handleOpenLateApprovalForm(item)}
                            >
                              {item.lateApproved ? <FaCheckCircle /> : <FaWpforms />}
                            </Button>
                          )}
                        </td>
                        <td>
                          {item.earlyCloseMinutes || "0"}
                          {earlyCloseDocs[item._id] && (
                            <Button
                              style={{
                                color: "#fff",
                                textDecoration: "none",
                                fontWeight: "500",
                                padding: "4px 8px",
                                backgroundColor: "#17a2b8",
                                borderRadius: "4px",
                                cursor: "pointer",
                                marginLeft: "9px",
                                border: "none",
                              }}
                              onClick={() =>
                                handleViewDocument(earlyCloseDocs[item._id], item, "earlyClose")
                              }
                            >
                              <IoEye />
                            </Button>
                          )}
                          {item.earlyCloseMinutes > 0 && (
                            <Button
                              variant={item.earlyCloseApproved ? "success" : "danger"}
                              size="sm"
                              style={{ marginLeft: "5px" }}
                              onClick={() => handleOpenEarlyLeaveApprovalForm(item)}
                            >
                              {item.earlyCloseApproved ? <FaCheckCircle /> : <FaWpforms />}
                            </Button>
                          )}
                        </td>
                        <td>
                          {item.extraMinutes || "0"}
                          {overtimeDocs[item._id] && (
                            <Button
                              style={{
                                color: "#fff",
                                textDecoration: "none",
                                fontWeight: "500",
                                padding: "4px 8px",
                                backgroundColor: "#17a2b8",
                                borderRadius: "4px",
                                cursor: "pointer",
                                marginLeft: "9px",
                                border: "none",
                              }}
                              onClick={() =>
                                handleViewDocument(overtimeDocs[item._id], item, "overtime")
                              }
                            >
                              <IoEye />
                            </Button>
                          )}
                          {item.extraMinutes > 0 && (
                            <Button
                              variant={item.overtimeApproved ? "success" : "danger"}
                              size="sm"
                              style={{ marginLeft: "5px" }}
                              onClick={() => handleOpenOvertimeApprovalForm(item)}
                            >
                              {item.overtimeApproved ? <FaCheckCircle /> : <FaWpforms />}
                            </Button>
                          )}
                        </td>
                        <td>
                          <div>
                            <Link to={item._id ? `/edit-atd/${item._id}` : "#"}>
                              <Button
                                variant="warning"
                                size="sm"
                                style={{ marginRight: "5px" }}
                                disabled={!item._id}
                              >
                                <FaEdit />
                              </Button>
                            </Link>
                            <Button
                              variant="success"
                              size="sm"
                              style={{ marginRight: "5px" }}
                              onClick={() => handleShowModal(item)}
                            >
                              <MdAccessTime />
                            </Button>
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => handleDeleteClick(item)}
                            >
                              <MdDelete />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
                <tfoot className="provident-fund-footer">
                  <tr className="provident-fund-table-footer">
                    <td>Total</td>
                    <td>{data.length}</td>
                    <td colSpan="8"></td>
                  </tr>
                </tfoot>
              </Table>
            )}
          </div>

          <div className="pagination-row">
            <div className="entries-info">
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
              {data.length} entries
            </div>
            <nav>
              <ul className="pagination no-gap">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>
                {pageRange().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      currentPage === pageNumber ? "active" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          size="lg"
          dialogClassName="fancy-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Attendance Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <strong>UserId:</strong> {modalData.userId || "--"}
            </p>
            <p>
              <strong>Name:</strong> {modalData.userName || "--"}
            </p>
            <p>
              <strong>CheckIn:</strong>{" "}
              {modalData.checkIn
                ? new Date(modalData.checkIn).toLocaleString()
                : "--"}
            </p>
            <p>
              <strong>CheckOut:</strong>{" "}
              {modalData.checkOut
                ? new Date(modalData.checkOut).toLocaleString()
                : "--"}
            </p>
            <p>
              <strong>Worked Hours:</strong> {modalData.workedHours || "--"}
            </p>
            <p>
              <strong>Late Minutes:</strong> {modalData.lateMinutes || "0"}
            </p>
            <p>
              <strong>Early Leave Minutes:</strong> {modalData.earlyCloseMinutes || "0"}
            </p>
            <p>
              <strong>Total Lost Minutes:</strong> {modalData.totalLostMinutes || "0"}
            </p>
            <p>
              <strong>Overtime Minutes:</strong> {modalData.extraMinutes || "0"}
            </p>
            <p>
              <strong>Late Reason:</strong> {modalData.lateReason || "Not provided"}
            </p>
            <p>
              <strong>Early Close Reason:</strong> {modalData.earlyCloseReason || "Not provided"}
            </p>
            <p>
              <strong>Overtime Reason:</strong> {modalData.overtimeReason || "Not provided"}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span>View Document</span>
              <div style={{ display: "flex", gap: "10px" }}>
                {selectedDocUrl && (
                  <Button
                    variant="outline-success"
                    style={{
                      borderRadius: "10px",
                      padding: "6px 16px",
                      fontWeight: "bold",
                      background: "linear-gradient(to right, #6a11cb, #2575fc)",
                      color: "#fff",
                      border: "none",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                      fontSize: "1rem",
                    }}
                    onClick={handleDownload}
                  >
                    <FaDownload />
                  </Button>
                )}
                <Button
                  variant="outline-warning"
                  style={{
                    borderRadius: "10px",
                    padding: "6px 16px",
                    fontWeight: "bold",
                    background: "linear-gradient(to right, #6a11cb, #2575fc)",
                    color: "#fff",
                    border: "none",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    fontSize: "1rem",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <TbReplaceFilled />
                </Button>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".jpg,.png,.pdf"
                  style={{ display: "none" }}
                  onChange={handleFileReplace}
                />
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "center" }}>
            {selectedDocUrl ? (
              selectedDocUrl.endsWith(".pdf") ? (
                <iframe
                  src={selectedDocUrl}
                  width="100%"
                  height="500px"
                  style={{ border: "none" }}
                  title="PDF Document Viewer"
                ></iframe>
              ) : (
                <img
                  src={selectedDocUrl}
                  alt="Uploaded Document"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                  onError={(e) => {
                    e.target.src = "/fallback-image.png";
                  }}
                />
              )
            ) : (
              <p style={{ color: "red", fontWeight: "bold" }}>
                No document available
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowViewModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showEarlyLeaveApprovalModal}
          onHide={() => {
            setShowEarlyLeaveApprovalModal(false);
            resetApprovalData();
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Early Leave Approval Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div ref={printRef} className="approval-form">
              <div className="form-details">
                <p>
                  <strong>Date:</strong> {approvalData.date || "--"}
                </p>
                <p>
                  <strong>Employee Name:</strong> {approvalData.userName || "--"}
                </p>
                <p>
                  <strong>Department:</strong> {approvalData.department || "--"}
                </p>
                <p>
                  <strong>Early Leave Minutes:</strong> {approvalData.minutes || "0"}
                </p>
                <p>
                  <strong>Reason:</strong> {approvalData.reason || "Not provided"}
                </p>
                <p>
                  <strong>Single Deduction Applied:</strong>{" "}
                  {approvalData.singleDeduction ? "Yes" : "No"}
                </p>
                {role === "admin" && !approvalData.adminHasApproved && (
                  <Form.Check
                    type="checkbox"
                    label="Apply Single Deduction"
                    checked={applySingleDeduction}
                    onChange={(e) => setApplySingleDeduction(e.target.checked)}
                    style={{ margin: "10px 0" }}
                  />
                )}
                <hr />
                <div className="signature-area mt-4">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>HR Signature</strong>
                      </p>
                      {approvalData.canEditHRSignature ? (
                        <Form.Control
                          type="text"
                          value={hrSignature}
                          onChange={(e) => setHrSignature(e.target.value)}
                          placeholder="Enter HR signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>Admin Signature</strong>
                      </p>
                      {approvalData.canEditAdminSignature ? (
                        <Form.Control
                          type="text"
                          value={adminSignature}
                          onChange={(e) => setAdminSignature(e.target.value)}
                          placeholder="Enter Admin signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {(approvalData.canEditHRSignature || approvalData.canEditAdminSignature) && (
              <Button
                variant="success"
                onClick={() => handleApprove("earlyClose")}
              >
                {approvalData.canEditHRSignature ? "Semi-Approve" : "Approve"}
              </Button>
            )}
            <Button
              variant="secondary"
              onClick={() => {
                setShowEarlyLeaveApprovalModal(false);
                resetApprovalData();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              <FaPrint /> Print
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showLateApprovalModal}
          onHide={() => {
            setShowLateApprovalModal(false);
            resetApprovalData();
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Late Approval Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div ref={printRef} className="approval-form">
              <div className="form-details">
                <p>
                  <strong>Date:</strong> {approvalData.date || "--"}
                </p>
                <p>
                  <strong>Employee Name:</strong> {approvalData.userName || "--"}
                </p>
                <p>
                  <strong>Department:</strong> {approvalData.department || "--"}
                </p>
                <p>
                  <strong>Late Minutes:</strong> {approvalData.minutes || "0"}
                </p>
                <p>
                  <strong>Reason:</strong> {approvalData.reason || "Not provided"}
                </p>
                <p>
                  <strong>Single Deduction Applied:</strong>{" "}
                  {approvalData.singleDeduction ? "Yes" : "No"}
                </p>
                {role === "admin" && !approvalData.adminHasApproved && (
                  <Form.Check
                    type="checkbox"
                    label="Apply Single Deduction"
                    checked={applySingleDeduction}
                    onChange={(e) => setApplySingleDeduction(e.target.checked)}
                    style={{ margin: "10px 0" }}
                  />
                )}
                <hr />
                <div className="signature-area mt-4">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>HR Signature</strong>
                      </p>
                      {approvalData.canEditHRSignature ? (
                        <Form.Control
                          type="text"
                          value={hrSignature}
                          onChange={(e) => setHrSignature(e.target.value)}
                          placeholder="Enter HR signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>Admin Signature</strong>
                      </p>
                      {approvalData.canEditAdminSignature ? (
                        <Form.Control
                          type="text"
                          value={adminSignature}
                          onChange={(e) => setAdminSignature(e.target.value)}
                          placeholder="Enter Admin signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {(approvalData.canEditHRSignature || approvalData.canEditAdminSignature) && (
              <Button
                variant="success"
                onClick={() => handleApprove("late")}
              >
                {approvalData.canEditHRSignature ? "Semi-Approve" : "Approve"}
              </Button>
            )}
            <Button
              variant="secondary"
              onClick={() => {
                setShowLateApprovalModal(false);
                resetApprovalData();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              <FaPrint /> Print
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showOvertimeApprovalModal}
          onHide={() => {
            setShowOvertimeApprovalModal(false);
            resetApprovalData();
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Overtime Approval Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div ref={printRef} className="approval-form">
              <div className="form-details">
                <p>
                  <strong>Date:</strong> {approvalData.date || "--"}
                </p>
                <p>
                  <strong>Employee Name:</strong> {approvalData.userName || "--"}
                </p>
                <p>
                  <strong>Department:</strong> {approvalData.department || "--"}
                </p>
                <p>
                  <strong>Overtime Minutes:</strong> {approvalData.minutes || "0"}
                </p>
                <p>
                  <strong>Reason:</strong> {approvalData.reason || "Not provided"}
                </p>
                <hr />
                <div className="signature-area mt-4">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>HR Signature</strong>
                      </p>
                      {approvalData.canEditHRSignature ? (
                        <Form.Control
                          type="text"
                          value={hrSignature}
                          onChange={(e) => setHrSignature(e.target.value)}
                          placeholder="Enter HR signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "center", width: "45%" }}>
                      <p>
                        <strong>Admin Signature</strong>
                      </p>
                      {approvalData.canEditAdminSignature ? (
                        <Form.Control
                          type="text"
                          value={adminSignature}
                          onChange={(e) => setAdminSignature(e.target.value)}
                          placeholder="Enter Admin signature"
                          style={{ margin: "10px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            borderBottom: "1px solid #000",
                            width: "100%",
                            margin: "10px auto",
                          }}
                        >
                          {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {(approvalData.canEditHRSignature || approvalData.canEditAdminSignature) && (
              <Button
                variant="success"
                onClick={() => handleApprove("overtime")}
              >
                {approvalData.canEditHRSignature ? "Semi-Approve" : "Approve"}
              </Button>
            )}
            <Button
              variant="secondary"
              onClick={() => {
                setShowOvertimeApprovalModal(false);
                resetApprovalData();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              <FaPrint /> Print
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDeleteModal}
          onHide={() => {
            setShowDeleteModal(false);
            setDeleteItem(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the attendance record for{" "}
            <strong>{deleteItem?.userName || "--"}</strong> on{" "}
            <strong>
              {deleteItem?.checkIn
                ? new Date(deleteItem.checkIn).toLocaleDateString()
                : "this date"}
            </strong>
            🤔?
            <br />
            <br />
            <strong>This action cannot be undone.</strong>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeleteModal(false);
                setDeleteItem(null);
              }}
              disabled={deleting}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteAttendance}
              disabled={deleting}
            >
              {deleting ? "Deleting..." : "Delete"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AtdLayout>
  );
};